import AbstractProvider from '../App/AbstractProvider';
import {IApp} from '../../@interfaces/services/App';

export default class WebSocketProvider extends AbstractProvider {
    async boot(app: IApp): Promise<void> {
        app.make('ws').initialize();
    }
}
